import {
    Button,
    MuiThemeProvider,
    createMuiTheme,
    TextField
} from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { Card, CardBody, CardHeader } from '../../../../_metronic/_partials/controls'
import { deleteFaq, getFaqById, postFaq, updateFaq } from '../../../../api/faq'
import { alertError, alertSuccess } from '../../../../utils/logger'
import MultilanguageTabBlock from '../../../components/MultilanguageTabBlock'
import { useSkeleton } from '../../../hooks/useSkeleton'
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";


// Create theme for delete button (red)
const theme = createMuiTheme({
    palette: {
        secondary: {
            main: "#F64E60",
        },
    },
});

function getEmptyText() {
    return {
        title: {
            'es': "",
            'en': ""
        },
        responseFaq: {
            'es': "",
            'en': ""
        },
        order: null
    }
}

export default function EditFaqPage() {
    const faqId = useParams().id;
    const history = useHistory();
    const { isLoading: isLoadingData, disableLoading: disableLoadingData, ContentSkeleton } = useSkeleton();

    const [faq, setFaq] = useState(getEmptyText())
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);


    useEffect(() => {
        if (!faqId) {
            disableLoadingData();
            return
        }

        getFaqById(faqId).then(res => {
            setFaq(res.data)
            disableLoadingData()
        }).catch(error => {
            alertError({ error: error, customMessage: 'Could not get faq.' })
            history.push('/faqs')
        })
    }, [faqId, disableLoadingData, history])

    function saveFaq() {
        if (!faqId) {
            postFaq(faq)
                .then((res) => {
                    alertSuccess({
                        title: "Saved!",
                        customMessage: "Frequently asked question created successfully.",
                    });
                    history.push("/faqs");
                })
                .catch((error) => {
                    alertError({
                        error: error,
                        customMessage: "Could not save the faq.",
                    });
                });
        } else {
            updateFaq(faqId, faq).then(res => {
                alertSuccess({ title: 'Saved!', customMessage: 'Changes successfully saved.' })
                history.push('/faqs')
            }).catch(error => {
                alertError({ error: error, customMessage: 'Could not save changes.' })
            })
        }
    }

    const handleChange = (element, lang) => (event) => {
        if (lang) {
            if (event.target.value === ' ')
                return
            if (!faq[element])
                faq[element] = {}
            let newText = faq[element]
            newText[lang] = event.target.value
            setFaq({ ...faq, [element]: newText })
        } else
            setFaq({ ...faq, [element]: event.target.value })
    }

    const renderMultilanguageTabContent = lang => {
        return (
            <>
                <TextField
                    label="Title"
                    value={(faq.title && faq.title[lang]) || ''}
                    onChange={handleChange('title', lang)}
                    margin="normal"
                    variant="outlined"
                    required
                />
                <TextField
                    value={(faq.responseFaq && faq.responseFaq[lang]) || ''}
                    onChange={handleChange('responseFaq', lang)}
                    label="FAQ response"
                    multiline
                    minRows={2}
                    maxRows={3}
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    inputProps={{
                        style: {
                            overflowY: 'auto',
                        },
                    }}
                    required

                />
            </>
        )
    }

    if (isLoadingData)
        return <ContentSkeleton />

    return (
        <>
            <Card>
                <CardHeader title='Edit frequently asked question'>
                </CardHeader>
                <CardBody>
                    <MultilanguageTabBlock
                        multilanguageTabContent={renderMultilanguageTabContent}
                    />
                </CardBody>
            </Card>
            <Button
                onClick={() => history.push('/faqs')}
                variant="outlined"
                style={{ marginRight: '20px' }}>
                Back
            </Button>
            <Button
                onClick={() => saveFaq()}
                variant="outlined"
                color="primary"
                style={{ marginRight: '20px' }}>
                Save faq
            </Button>

            {faqId && (
                <>
                    <MuiThemeProvider theme={theme}>
                        <Button
                            onClick={() => setOpenConfirmDialog(true)}
                            variant="outlined"
                            color="secondary"
                            style={{ marginRight: "20px" }}
                        >
                            Delete faq
                        </Button>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                marginLeft: "auto",
                            }}
                        ></div>
                    </MuiThemeProvider>

                    <ConfirmDialog
                        title={"Are you sure you want to delete this faq?"}
                        open={openConfirmDialog}
                        setOpen={setOpenConfirmDialog}
                        onConfirm={() => {
                            deleteFaq(faqId)
                                .then((res) => {
                                    alertSuccess({
                                        title: "Deleted!",
                                        customMessage: "Faq deleted successfully.",
                                    });
                                    history.push("/faqs");
                                })
                                .catch((error) => {
                                    alertError({
                                        error: error,
                                        customMessage: "Could not delete the faq.",
                                    });
                                });
                        }}
                    />
                </>
            )}
        </>
    );
}